import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';

import { Auth0Client } from '@auth0/auth0-spa-js';
import { DevCycleUser } from '@devcycle/js-client-sdk';
import { Router } from '@angular/router';
import { Userpilot } from 'userpilot';

import { version } from 'package.json';

// Configura el cliente Auth0
const auth0Client = new Auth0Client({
  domain: environment.authDomain,
  clientId: environment.authClientId,
});

// Verifica la autenticación antes de inicializar la aplicación Angular
async function bootstrap() {
  try {
    await auth0Client.getTokenSilently();
    const user = await auth0Client.getUser();
    if (user) {
      const devCycleUser: DevCycleUser = {
        user_id: user.sub, // ID único del usuario en Auth0
        email: user.email,
        name: user.name,
        // Otros campos según necesidades
      };
      sessionStorage.setItem('devCycleUser', JSON.stringify(devCycleUser));
    }

    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  } catch (error) {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .then((moduleRef) => {
        if (!window.location.href.includes('/public/')) {
          const router = moduleRef.injector.get(Router);
          router.navigate(['/']);
        }
      })
      .catch((err) => console.error(err));
    // Manejo de errores, por ejemplo, redirigir a la página de inicio de sesión
    // O mostrar un mensaje al usuario para que inicie sesión
  }
  try {
    Userpilot.initialize(environment.userpilotToken);
  } catch (error) {
    console.error('Error initializing Userpilot', error);
  }
}

bootstrap();

// Initialize Sentry
function initializeSentry() {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.name,

    // Session replay for error diagnosis
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Capture all sessions with errors

    // Integrations
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.routingInstrumentation,
        tracingOrigins: ['localhost', window.location.hostname],
      }),
      new Sentry.Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Better grouping with custom fingerprinting
    beforeSend(event) {
      // Don't send certain errors
      if (event.exception && event.exception.values) {
        const exceptionValue = event.exception.values[0];

        // Skip certain network errors
        if (
          exceptionValue.value &&
          (exceptionValue.value.includes('Failed to fetch') ||
            exceptionValue.value.includes('NetworkError') ||
            exceptionValue.value.includes('Network request failed'))
        ) {
          return null;
        }

        // Skip ResizeObserver errors (common and usually harmless)
        if (
          exceptionValue.value &&
          exceptionValue.value.includes('ResizeObserver loop')
        ) {
          return null;
        }
      }

      return event;
    },

    // Sanitize sensitive data
    beforeBreadcrumb(breadcrumb) {
      // Don't capture passwords or sensitive data in breadcrumbs
      if (
        breadcrumb.category === 'ui.input' &&
        breadcrumb.message &&
        (breadcrumb.message.includes('password') ||
          breadcrumb.message.includes('token') ||
          breadcrumb.message.includes('credit'))
      ) {
        return null;
      }

      return breadcrumb;
    },
  });
}

if (environment.production) {
  enableProdMode();
}

// Always initialize Sentry, but with different configurations based on environment
initializeSentry();

/* platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err)); */
